"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatingPeriodEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../../../Form/Field/Select/legacy");
const repeatingPeriodItems = [
    {
        value: 'day',
        name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:Day', defaultMessage: 'day' })),
    },
    {
        value: 'week',
        name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:Week', defaultMessage: 'week' })),
    },
    {
        value: 'month',
        name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:Month', defaultMessage: 'month' })),
    },
];
const RepeatingPeriodEditor = (props) => {
    const { field } = props;
    const fieldProps = {
        name: 'period',
        modificators: field.modifiers,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:Period', defaultMessage: 'Repeat every' })),
        value: field.value,
        error: field.error,
        onChange: field.onEvent,
        items: repeatingPeriodItems,
    };
    return (react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...fieldProps }));
};
exports.RepeatingPeriodEditor = RepeatingPeriodEditor;
//# sourceMappingURL=RepeatingPeriodEditor.js.map